<template>
    <div>
        <JhmaHeader/>
        <article class="thank-you-page">
            <FormHeader/>
            <ShowStep :current="3"/>
            <h2>資格試験申し込み完了</h2>
            <section class="section-one">
                <h3>お申し込みありがとうございました。</h3>
                <p class="information">
                    在宅看護指導士資格試験のお申し込みが完了いたしました。
                </p>
                <p class="mt-4">
                    お申し込み情報の確認
                </p>
                <p>
                    メールアドレス: <span id="apply-email">{{ applyEmail }}</span>
                </p>
                <p>
                    電話番号: <span id="apply-tel">{{ applyTel }}</span>
                </p>
            </section>
            <div class="contact-info">
                <ul>
                    <li>
                        <h6>メールでのお問い合わせ</h6>
                        <p>contact@jhma.or.jp</p>
                    </li>
                </ul>
            </div>
            <section class="section-two flex justify-center">
                <a href="https://jhma.or.jp"
                   class="block w-[260px] text-base transition rounded-full bg-gradient-to-r from-[#31abd6] to-[#b5e154] p-1">
                <span
                    class="flex items-center justify-center w-full h-full bg-white rounded-full text-[#0A90B1] font-medium relative p-2">
                TOPページへ
                     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                          stroke-width="1.5" stroke="currentColor"
                          class="w-6 h-6 absolute right-2 top-0 bottom-0 my-auto">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                  d="M8.25 4.5l7.5 7.5-7.5 7.5"/>
                                        </svg>
                </span>
                </a>
            </section>
        </article>
        <JhmaFooter/>
    </div>
</template>

<script>
import SectionLabel from "../../parts/app/SectionLabel";
import FormHeader from "../../parts/app/FormHeader";
import ShowStep from "../../parts/app/ShowStep";
import JhmaHeader from "../../parts/app/JhmaHeader.vue";
import JhmaFooter from "../../parts/app/JhmaFooter.vue";

export default {
    name: "ThankYou",
    components: {JhmaFooter, JhmaHeader, ShowStep, FormHeader, SectionLabel},

    computed: {
        applyEmail() {
            if (!this.$route.query.m) {
                return undefined;
            }
            return atob(this.$route.query.m);
        },
        applyTel() {
            if (!this.$route.query.t) {
                return undefined;
            }
            return atob(this.$route.query.t);
        }
    }
}
</script>

<style scoped>
h2 {
    @apply text-main-color relative mt-10;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    line-height: 40px;
    letter-spacing: 0.16em;
}

h2:after {
    @apply absolute;
    width: 40px;
    height: 2px;
    content: "";
    background-color: #d11a30;
    margin-right: auto;
    margin-left: auto;
    bottom: -20px;
    left: 0;
    right: 0;
}

h3 {
    @apply text-main-color;
    font-size: 18px;
    line-height: 63px;
    letter-spacing: 0.12em;
}

.section-one {
    @apply mt-4 lg:text-center p-2;
}

.section-two {
    @apply p-2 lg:text-center mt-8;
}

.information {
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 0.1em;
}

.notice {
    @apply mt-4;
    color: #e5495c;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.1em;
}

.contact-info {
    @apply max-w-full mx-auto mt-8 p-8;
    width: 800px;
    background-color: #f2f8fb;
}

.contact-info ul {
    @apply flex flex-col lg:flex-row justify-center;
}

.contact-info ul li {
    @apply lg:text-center flex-1 relative;
}

.contact-info ul li:not(:first-of-type) {
    @apply mt-4 lg:mt-0;
}

.contact-info ul li:not(:last-of-type):after {
    @apply absolute h-full top-0 bottom-0 right-0 hidden lg:block;
    content: "";
    background-color: #dfe8ec;
    width: 1px;
}

.contact-info ul li h6 {
    font-size: 16px;
    letter-spacing: 0.12em;
}

.contact-info ul li p {
    @apply mt-2;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0.12em;
    color: #006098;
}

.contact-info > p {
    @apply mt-8 lg:text-center;
    font-size: 14px;
    letter-spacing: 0.1em;
}
</style>
